import Facebook from "../images/Footer/Facebook.svg";
import Reverbnation from "../images/Footer/Reverbnation.png";
import Youtube from "../images/Footer/YouTube.svg";
import Spotify from "../images/Footer/Spotify.svg";
import Deezer from "../images/Footer/Deezer.svg";
import Apple_Music from "../images/Footer/Apple_Music.svg";


const Footer = () => {
  return (
    <div className="container__footer">
      <footer>
        <a
          href="https://www.facebook.com/claudinefrancoismusic"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={Facebook}
            alt="Facebook"
            className="footer__icon"
          />
        </a>
        <a
          href="https://www.reverbnation.com/claudinefrancois"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={Reverbnation}
            style={{objectFit: "cover"}}
            alt="Reverbnation"
            className="footer__icon"
          />
        </a>
        <a
          href="https://www.youtube.com/user/claudinefrancoisjazz"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={Youtube}
            alt="Youtube"
            className="footer__icon"
          />
        </a>
        <a
          href="https://open.spotify.com/intl-fr/artist/7jdSr9H7KxxBLWSxy68ibo"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={Spotify}
            alt="Spotify"
            className="footer__icon"
          />
        </a>
        <a
          href="https://www.deezer.com/search/claudine%20francois"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={Deezer}
            alt="Deezer"
            className="footer__icon"
          />
        </a>
        <a
          href="https://music.apple.com/fr/artist/claudine-francois/349536324"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={Apple_Music}
            alt="Apple Music"
            className="footer__icon"
          />
        </a>
      </footer>
    </div>
  );
};

export default Footer;
